export const emailSent = {
  created() {
    this.$on('sent:email', this.showMessage.bind(this))

    if (Object.prototype.hasOwnProperty.call(this.$root, 'sent-email')) {
      return
    }

    Object.defineProperty(this.$root, 'sent-email', {
      value: this.createMessageElement(),
      writable: false
    })
  },
  computed: {
    savedMessage() {
      return this.$root['sent-email']
    }
  },
  methods: {
    showMessage(email) {
      this.savedMessage.innerText = this.$t('messageEmail.tooltipPasswordChange', { '1': email })
      this.savedMessage.classList.remove('hide')
      setTimeout(() => {
        this.savedMessage.classList.add('hide')
      }, 4000)
    },
    createMessageElement() {
      let msgElement = document.createElement('div')
      msgElement.className = 'card card-message card-message-normal hide'
      msgElement.innerText = this.$t('messageEmail.passwordChange')
      document.body.appendChild(msgElement)
      return msgElement
    }
  }
}
